define('v3/Pages/Check/Services/Check.Service',[
	'lodash',
	'module',
	'v3/FromV2/localStorageV3Service',
	'v3/Common/Components/SubjectsDropdown/Services/subjectService',
	'v3/Common/Services/urlService'
], function (_, module, localStorageV3Service, subjectService, urlService) {
	function CheckService () {
		var self = this;

		self.NormalizeAbilityGrowthInClass = function (pupils) {
			var maxValue = 1;
			_.forEach(pupils,
				function (pupil) {
					maxValue = Math.max(maxValue, pupil.abilityGrowth, pupil.targetAbilityGrowth);
				});
			_.forEach(pupils,
				function (pupil) {
					pupil.abilityGrowthPercent = pupil.abilityGrowth < 0 ? 0 : Math.round(pupil.abilityGrowth * 100 / maxValue);
					pupil.targetAbilityGrowthPercent = pupil.targetAbilityGrowth < 0
						? 0
						: Math.round(pupil.targetAbilityGrowth * 100 / maxValue);
				});
			return pupils;
		};

		self.setPageState = function (activeView, pupilId) {
			localStorageV3Service.setCheckPageStateLocalStorage({ activeView: activeView, pupilId: pupilId });
		};

		self.getPageStateView = function () {
			var pageState = localStorageV3Service.getCheckPageStateLocalStorage();
			if (pageState) {
				return pageState.activeView;
			}
			return null;
		};

		self.getPageStatePupilId = function () {
			var pageState = localStorageV3Service.getCheckPageStateLocalStorage();
			if (pageState) {
				return pageState.pupilId;
			}
			return null;
		};

		self.getSubjectGroupsByEducationPlanAvailability = function () {
			return subjectService.getSubjectsWhereEducationPlanExistsForClass();
		};

		self.goToTeach = function () {
			window.location.href = module.config().actions.goToTeach;
		};

		self.goToSchoolReport = function () {
			window.location.href = module.config().actions.goToSchoolReport;
		};

		self.goToPupilDetails = function (pupilId, subjectGroupId) {
			urlService.pupilReviewPageUrl(subjectGroupId, pupilId).done(function (url) {
				window.location.href = url;
			});
		};
	}

	return new CheckService();
});

